import React from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import {
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_LIBRARIES,
} from "../../../config/googleMaps";
import { GoogleMapsContext } from "./GoogleMapsContext";

const GoogleMapsPlacesProvider = ({ children }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "sr-google-maps-script",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
    language: "en",
    region: "US",
  });

  const placesEnabled = isLoaded && !loadError;

  return (
    <GoogleMapsContext.Provider value={{ placesEnabled }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export default GoogleMapsPlacesProvider;
